import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 75A03574-02AA-4377-8DE3-86CBE77A0957
 * name seed
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/seed.svg
 * tags
 * - Agriculture 
 * - Nature 
 * - Food / Drink 
 */
export const SeedIcon = createSvgIcon(<><path d="M20.7,3.3C20.7,3.3 19.3,3 17.2,3C11.7,3 1.6,5.1 3.2,20.8C4.3,20.9 5.4,21 6.4,21C24.3,21 20.7,3.3 20.7,3.3M7,17C7,17 7,7 17,7C17,7 11,9 7,17Z" /></>, 'SeedIcon');
export default SeedIcon